<template>
    <div class="wrap">
        <div class="row">
            <div class="col-1">
                <br>
                <div style="padding-left:10px;font-size:30px;">
                    <a class="link_1" onclick="history.back(-1);return false;"><i class="bi bi-x"></i></a>
                </div>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col text-center">
                <h1>会社概要</h1>
                <div class="luna-hr"></div>
            </div>
        </div>
        <br>
        <div class="row justify-content-center">
            <div class="col-10">
                <hr>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-3">
                <b>社名</b>
            </div>
            <div class="col-7">
                <b>株式会社Luna</b>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-10">
                <hr>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-3">
                <b>設立</b>
            </div>
            <div class="col-7">
                <b>２０２２年８月１７日</b>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-10">
                <hr>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-3">
                <b>事業内容</b>
            </div>
            <div class="col-7">
                <b>SMマッチングサイト「Luna」</b>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-10">
                <hr>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-3">
                <b>資格</b>
            </div>
            <div class="col-7">
                <b>インターネット異性紹介事業　届出済み<br>登録番号 30240011-000</b>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-10">
                <hr>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-3">
                <b>所在地</b>
            </div>
            <div class="col-7">
                <b>〒153-0064<br>東京都目黒区下目黒2丁目18-3 401</b>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-10">
                <hr>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-3">
                <b>電話番号</b>
            </div>
            <div class="col-7">
                <b>03-6892-7252</b>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-10">
                <hr>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        };
    },
    created() {
        window.location.href = "https://luna-company.com/about"
    },
}
</script>
<style scoped>
.link_1 {
    color: #000;
}

.link_1:hover {
    color: #000;
}

.link_1:link {
    color: #000;
}

.link_1:visited {
    color: #000;
}

.luna-hr {
    border-top: 5px solid #6B4EFF;
    border-right: none;
    border-bottom: none;
    border-left: none;
    width: 100px;
    margin: auto;
    border-radius: 10px;
}
</style>
